import React from 'react';
import { Link } from 'react-router-dom';
import { resolveClientLifecycle, getProgramTier } from '../utils/accountLifecycle';

/**
 * Summary of the portal user’s enrolled program (from linked `accounts` doc).
 */
export default function PortalYourPlanBanner({ account }) {
  const prog = account?.program;
  if (!prog) return null;

  const monthly =
    prog.monthlyAmount != null ? `$${Number(prog.monthlyAmount).toLocaleString()}` : '—';
  const cycleRaw = (prog.billingCycle || account?.billingCycle || 'monthly').toString();
  const cycleDisplay =
    cycleRaw.charAt(0).toUpperCase() + cycleRaw.slice(1).toLowerCase();
  const lifecycleState = resolveClientLifecycle(account).state;
  const statusLabel = lifecycleState === 'Active' ? 'Active' : lifecycleState === 'Canceling' ? 'Canceling' : 'Inactive';
  const programLabel = getProgramTier(account) || prog.name || '—';

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800/80 shadow-sm mb-8 p-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Your plan</h2>
        <Link
          to="/portal/billing"
          className="text-sm font-medium text-red-600 dark:text-red-400 hover:underline shrink-0"
        >
          Billing & invoices →
        </Link>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
        <div>
          <div className="text-gray-500 dark:text-gray-400 font-medium mb-0.5">Program</div>
          <div className="font-semibold text-gray-900 dark:text-white">{programLabel}</div>
        </div>
        <div>
          <div className="text-gray-500 dark:text-gray-400 font-medium mb-0.5">Monthly amount</div>
          <div className="font-semibold text-gray-900 dark:text-white">{monthly}</div>
        </div>
        <div>
          <div className="text-gray-500 dark:text-gray-400 font-medium mb-0.5">Billing cycle</div>
          <div className="font-semibold text-gray-900 dark:text-white">{cycleDisplay}</div>
        </div>
        <div>
          <div className="text-gray-500 dark:text-gray-400 font-medium mb-0.5">Status</div>
          <div className="font-semibold text-gray-900 dark:text-white">{statusLabel}</div>
        </div>
      </div>
    </div>
  );
}
